@if (!submitted) {
  <div style="width: 100%">
    <form [formGroup]="contentForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label class="center-block">Google Doc ID:
        </label>
        <input class="form-control" formControlName="google_doc_id"
          [ngClass]="{ 'is-invalid': submitted && f.google_doc_id.errors }" />
        @if (submitted && f.google_doc_id.errors) {
          <div class="invalid-feedback">
            @if (f.google_doc_id.errors.required) {
              <div>Google Doc ID Required</div>
            }
          </div>
        }
      </div>
      <div style="margin-bottom: 1em; text-align:right;">
        <button type="submit" [disabled]="contentForm.pristine">
          Save
        </button>
        <button type="button" (click)="onCancel()" style="margin-left: 10px;">Cancel</button>
        &nbsp;
      </div>
    </form>
  </div>
}

@if (submitted) {
  <div>
    Processing...
  </div>
}